/**
 * Picks readable text colour (black or white) against an arbitrary tag background colour, by
 * relative luminance. Copied from `TagBadge`'s own `getTextColor` (`components/UI/TagBadge`), not
 * imported: `TagBadge` is a separate, still-Tailwind atom shared broadly outside this task's scope
 * (the unmigrated `TagSelector`/`BulkAssignTagsTab` still render through it) — see `Detail.tsx`'s
 * own docstring for why the per-material tag chips render through their own small Carbon-styled
 * swatch instead of reusing it. Pure and dumb on purpose: no JSX, no i18n, unit-testable without
 * rendering anything.
 */
export const getTagTextColor = (hexColor?: string | null): string => {
  // A tag can come back with no colour set; a short/missing value has no luminance to weigh, so
  // fall back to black text (readable on the neutral swatch the caller renders in that case).
  const hex = (hexColor ?? "").replace("#", "");
  if (hex.length < 6) return "#000000";
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "#000000" : "#FFFFFF";
};
